import { Injectable } from '@angular/core';
import { Subscription, Subject, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfficeDataService {
  private _handler: Subject<string> = new Subject<string>();

  boradcast(text: string) {
    this._handler.next(text);
  }

  subscribe(callback: (text: any) => void): Subscription {
    return this._handler.subscribe(callback);
  }
  /* SGF - SingleGridForm
   * RGW - ReportGateway*/
  public OfficeNavBarOn = false;
  public ModalMsg = "Please Wait ..."
  public SGFSubOn = false;
  public SGFIsNewRow = null;
  public SGFRowDataEdit = {};
  public SGFCombobox = {};
  public SGFCompany = null;
  public SGFForm = null;
  public SGFCompanyList = [];
  public SGFFormList = [];
  public SGFFormMetadata: [{ [key: string]: any}];
  public SGFFormData = [];
  public SGFMode = null;
  public SGFTitle = null;
  public SGFStaticLookupsResponse: [{ [key: string]: any }];
  public SGFRoute = null;
  public SGFSortList = [];
  public SGFFilteringList = {};
  public SGFCurrentFormReadOnly = false;

  public RGWSubOn = false;
  public RGWCat = "All";
  constructor() { }
}
